/** POST .../branches/:branchId/petty-expenses/transaction (CreatePettyExpenseTransactionDto). */

function pickLine(line: Record<string, unknown>): Record<string, unknown> {
  const payload: Record<string, unknown> = {
    type: String(line.type ?? ''),
    amount: line.amount,
  };
  const optional = [
    'date',
    'borrowerName',
    'employee',
    'borrowerId',
    'accountHolderName',
    'accountHolderId',
    'purchasedItem',
    'billType',
    'description',
    'modeOfPayment',
  ] as const;
  for (const key of optional) {
    const value = line[key];
    if (value !== undefined && value !== null && value !== '') {
      payload[key] = value;
    }
  }
  return payload;
}

export function buildPettyExpenseTransactionPayload(
  data: Record<string, unknown>,
): Record<string, unknown> {
  const d = data ?? {};
  const lines = Array.isArray(d.lines) ? d.lines : [];
  const payload: Record<string, unknown> = {
    user: String(d.user ?? ''),
    lines: lines.map((line) => pickLine(line as Record<string, unknown>)),
  };
  const optional = [
    'branch',
    'company',
    'createdBy',
    'activityBy',
    'modeOfPayment',
    'description',
    'date',
  ] as const;
  for (const key of optional) {
    const value = d[key];
    if (value !== undefined && value !== null && value !== '') {
      payload[key] = value;
    }
  }
  return payload;
}

export function pettyExpenseTransactionUrl(branchId: string): string {
  return `branches/${branchId}/petty-expenses/transaction`;
}

export function buildDeletePettyExpensePayload(
  expense: Record<string, unknown>,
): Record<string, unknown> {
  return {
    _id: String(expense._id ?? ''),
    amount: Number(expense.amount ?? 0),
    createdBy: String(expense.createdBy ?? expense.user ?? ''),
  };
}

export function pettyExpenseDeleteUrl(branchId: string): string {
  return `branches/${branchId}/petty-expenses/actions/delete-petty-expense`;
}

/** POST .../branches/:branchId/petty-expenses/:id/actions/lending-returned */
export function pettyExpenseLendingReturnedUrl(branchId: string, id: string): string {
  return `branches/${branchId}/petty-expenses/${id}/actions/lending-returned`;
}

/** PUT .../branches/:branchId/petty-expenses/actions/upload */
export function pettyExpenseUploadUrl(branchId: string): string {
  return `branches/${branchId}/petty-expenses/actions/upload`;
}

export function extractCreatedPettyExpenseIds(res: unknown): string[] {
  if (!res || typeof res !== 'object') {
    return [];
  }
  const body = res as Record<string, unknown>;
  const nested = body.response as Record<string, unknown> | undefined;
  const ids = nested?.createdExpenseIds ?? body.createdExpenseIds;
  if (!Array.isArray(ids)) {
    return [];
  }
  return ids.map((id) => String(id));
}
